// Standard library imports
import React from 'react';
// Internal module imports
import { Logs } from './Logs';
import TabsComponent from '../../../../../components/Tabs/Tabs';
import { Notes } from './Notes';

export const NotesLogsIndex = ({ bid, closeModal, bidType }) => {
    let tabs = [
        {
            name: 'Logs',
            component: (
                <>
                    <Logs bid={bid} bidType={bidType} />
                </>
            ),
        },
        {
            name: 'Notes',
            component: (
                <>
                    <Notes bid={bid} closeModal={closeModal} bidType={bidType} />
                </>
            ),
        },
    ];

    return (
        <div>
            <TabsComponent selectedIndex={0} tabs={tabs} />
        </div>
    );
};
